<template>
  <div class="home-page">
    <section class="home-banner">
        <div class="container">
            <div class="row">
                <div class="col-sm pt-5 pb-4">
                    <div class="head-title">
                        <h1>Hooray, we're CodeHit</h1>
                        <p> We make apps that solves specific unit of task. And we love finding one for your specific needs. No kidding <a href="/contact" class="">talk to us</a> or check our apps 😉. </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div class="container">
        <section>
            <h3 class="mt-5 mb-4">Our Stories</h3>
        </section>
    </div>
    <section class="bg-1 p-4">
        <div class="container">
            <div class="row">
                <div class="col-sm-6">
                    <div>
                        <a href="/merp" class="">
                            <div class="merp-banner"><img src="/img/merp.png" alt="mERP" class="img-fluid"></div>
                        </a>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="pt-4">
                        <h2>@mERP</h2>
                        <p class="body-1"> Way back in time a friend of us outgrown thier retail business solutions. They want a more granular set of tools that does just a specific task. We identity these specific unit of task and create a specific tool just for it. As we progress we see that we got the tools that just does the job and so <a href="/merp" class="">mERP</a> is born. </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="p-4">
        <div class="container">
            <div class="row">
                <div class="col-sm-6">
                    <div class="pt-4">
                        <h2>@moneyMonit</h2>
                        <p class="body-1"> We needed a tool just to track our balance from different bank accounts including cash on hands and debts, <a href="/money-monit" class="">moneyMonit</a> is created to do the job. </p>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div>
                        <a href="/money-monit" class="">
                            <div class="merp-banner"><img src="/img/money-monit.png" alt="mERP" class="img-fluid"></div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="p-4">
        <div class="container">
            <div class="row">
                <div class="col-sm-12 text-center">
                    <div class="pt-4">
                        <p class="body-1"> And so much stories to tell. <a href="/contact" class="">Have a chat with us.</a></p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <Footer/>
</div>
</template>

<script>

import Footer from '@/components/Footer.vue'

export default {
  name: 'ActMonit',
  components: {
    Footer
  }
}
</script>

<style lang="scss">
  .banner-section {
    background:#f8f9fa url('/img/cityscape.png') no-repeat center bottom;
  }
  .merp-banner {
    overflow: hidden;
    height: 350px;
    text-align: center;
    box-shadow: -2px 2px 7px -1px rgba(0,0,0,0.2);
  }
  .head-title h1{font-size:4rem}
  .head-title p{font-size:1.5rem;color:#495057}
  p.body-1{
    font-size:1.1rem
  }
  .text-gray,p.body-1{
      color:#495057
  }

  .home-banner{
      background:#f8f9fa url(/img/cityscape.png) no-repeat bottom
  }
  .bg-1{
      background:#f8f9fa
  }
  .merp-banner{
    overflow:hidden;
    height:350px;
    text-align:center;
    box-shadow:-2px 2px 7px -1px rgba(0,0,0,.2)
  }
</style>